import { render } from "./UploadBankStatement.vue?vue&type=template&id=2b1c0dd0&scoped=true"
import script from "./UploadBankStatement.vue?vue&type=script&lang=js"
export * from "./UploadBankStatement.vue?vue&type=script&lang=js"

import "./UploadBankStatement.vue?vue&type=style&index=0&id=2b1c0dd0&lang=scss&scoped=true"

import exportComponent from "D:\\Epaylater Projects\\microapp-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b1c0dd0"]])

export default __exports__